// Self-contained data for the TLC Law Firm concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/08_TLC_Law_Firm (research snapshot 2026-08-21).
// Ownership/managing-partner status is unresolved — Jamaal James Calipayan is publicly
// associated with the firm but is NOT presented as founder/owner. Office address has two
// current variants in public listings — presented with a note to confirm. Review data is
// unreliable (StarOfService currently shows 0 reviews) — no rating is shown.
export const BIZ = {
  name: "TLC Law Firm",
  tagline: "Legal Advice, Civil & Family Matters in Mandaue",
  address: "2L A.S. Fortuna St., Mandaue City, Cebu",
  addressNote: "A separate current listing shows 273 A. Del Rosario Street, Mandaue — please confirm the current office before visiting.",
  phone: "+63324200989",
  phoneDisplay: "(032) 420-0989",
  email: "tlclawfirmph@gmail.com",
  mapEmbed: "https://www.google.com/maps?q=A.S.+Fortuna+St+Mandaue+City+Cebu&output=embed",
};

export const SERVICES = [
  { title: "Legal Advice", text: "General legal advice and consultation." },
  { title: "Civil Matters", text: "Civil law representation and support." },
  { title: "Family Matters", text: "Family law concerns and legal support." },
  { title: "Contracts & Documents", text: "Contracts and legal-document preparation." },
];

export const PROFESSIONAL = {
  name: "Jamaal James Calipayan",
  note: "Publicly associated with our office in Cebu. A public professional profile describes 15+ years of senior legal/governance leadership experience — a self-described background, not a title we're presenting as independently verified.",
};

export const POSITIONING = "We describe our own practice as delivering prompt and expert legal services customized to client needs.";
